import type { UiContactProps } from '@afs/design-system/components/molecules/UiContact/interface.js'
import type { UiFocusProps } from '@afs/design-system/components/molecules/UiFocus/interface.js'
import type { TextBlockType } from '~/extensions/utils/common/textBlock/textBlock.type'

/**
 * Chacune des fonctions permet de vérifier si au moins l'un des champs du bloc souhaité est spécifié.
 * Si oui on renvoie true et on doit l'afficher
 */

export function shouldDisplayTextBlock(data: TextBlockType): boolean {
  return (
    !isFieldEmpty(data.title) ||
    !isFieldEmpty(data.chapo) ||
    !isFieldEmpty(data.subtitle) ||
    !isFieldEmpty(data.content)
  )
}

export function shouldDisplayInfoBlock(data: UiFocusProps) {
  return !isFieldEmpty(data.title) || !isFieldEmpty(data.description) || !isFieldEmpty(data.illustration)
}

export function shouldDisplayPhoneBlock(data: UiContactProps) {
  return (
    !isFieldEmpty(data.surtitle) ||
    !isFieldEmpty(data.title) ||
    !isFieldEmpty(data.phone) ||
    !isFieldEmpty(data.subtitle) ||
    !isFieldEmpty(data.caption)
  )
}

function isFieldEmpty(field: string | undefined) {
  return !field || field.trim() === ''
}
